import { useState } from "react";
import { Search, User } from "lucide-react";

export default function SearchableChildSelect({ 
  childrenList = [], 
  value, 
  onChange, 
  placeholder = "Pilih kanak-kanak",
  disabled = false,
  className = ""
}) {
  const [search, setSearch] = useState("");

  // Find selected child
  const selectedChild = childrenList.find(c => c.id === value);

  // Filter children based on search
  const filteredChildren = search.trim() 
    ? childrenList.filter(child => 
        child.name?.toLowerCase().includes(search.toLowerCase())
      )
    : childrenList;

  const handleSelect = (childId) => {
    if (value === childId) {
      onChange(""); // Deselect if already selected
    } else {
      onChange(childId);
    }
  };

  return (
    <div className={className}>
      {/* Search Input */}
      <div className="relative mb-3">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Cari nama kanak-kanak..."
          disabled={disabled}
          className="w-full pl-12 pr-4 py-3 bg-white border-2 border-gray-200 rounded-full text-gray-700 text-base placeholder-gray-400 focus:outline-none focus:border-pink-300 disabled:opacity-50"
          style={{ fontSize: '16px' }}
        />
      </div>

      {/* Children List - Scrollable with max height */}
      <div 
        className="bg-gray-50 rounded-2xl overflow-hidden"
        style={{ maxHeight: '200px', overflowY: 'auto' }}
      >
        {filteredChildren.length === 0 ? (
          <div className="p-6 text-center">
            <User className="w-10 h-10 text-gray-300 mx-auto mb-2" />
            <p className="text-gray-500 text-sm">
              {search ? `Tiada hasil untuk "${search}"` : "Tiada kanak-kanak"}
            </p>
          </div>
        ) : (
          <div className="divide-y divide-gray-200">
            {filteredChildren.map((child) => {
              const isSelected = value === child.id;
              return (
                <div
                  key={child.id}
                  onClick={() => !disabled && handleSelect(child.id)}
                  className={`flex items-center gap-3 p-4 cursor-pointer transition-colors ${
                    disabled ? 'opacity-50 cursor-not-allowed' : 'active:bg-gray-100'
                  } ${isSelected ? 'bg-pink-50' : ''}`}
                >
                  {/* Radio/Checkbox Circle */}
                  <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${
                    isSelected 
                      ? 'border-pink-500 bg-pink-500' 
                      : 'border-gray-300 bg-white'
                  }`}>
                    {isSelected && (
                      <div className="w-2 h-2 rounded-full bg-white" />
                    )}
                  </div>
                  
                  {/* Name */}
                  <span className={`text-base ${isSelected ? 'text-pink-700 font-semibold' : 'text-gray-700'}`}>
                    {child.name}
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Selected indicator */}
      {selectedChild && (
        <p className="mt-2 text-sm text-pink-600 font-medium">
          ✓ Dipilih: {selectedChild.name}
        </p>
      )}
    </div>
  );
}
